export const checkboxNimbus =
  "z-10 w-6 h-6 h-5 w-5 text-[#1A3D82] border-[#1A3D82] rounded-md border";

export const checkboxCardStyles =
  "absolute z-[9] top-2 right-2 w-6 h-6 h-5 w-5 text-[#1A3D82] border-[#1A3D82] rounded-md border";

export const checkboxLabel = "text-nimbusLight font-bold ml-2 flex-1";
